/**
 * 根据 name 生成稳定的头像背景(首字母方块用)。
 *
 * 升级:从平面色改成 135° 渐变,两色同色系做微妙过渡。
 * 10 组 palette,hash 模运算决定同名永远同色。
 */
const PALETTE: Array<[string, string]> = [
  ["#6366f1", "#4338ca"], // indigo
  ["#ec4899", "#be185d"], // pink
  ["#10b981", "#047857"], // emerald
  ["#f59e0b", "#b45309"], // amber
  ["#3b82f6", "#1d4ed8"], // blue
  ["#8b5cf6", "#6d28d9"], // violet
  ["#ef4444", "#b91c1c"], // red
  ["#14b8a6", "#0f766e"], // teal
  ["#f97316", "#c2410c"], // orange
  ["#06b6d4", "#0e7490"], // cyan
];

function hashString(s: string): number {
  let h = 0;
  for (let i = 0; i < s.length; i++) {
    h = (h << 5) - h + s.charCodeAt(i);
    h |= 0;
  }
  return Math.abs(h);
}

/** 返回 CSS linear-gradient 字符串 */
export function avatarColor(name: string): string {
  const pair = PALETTE[hashString(name) % PALETTE.length]!;
  return `linear-gradient(135deg, ${pair[0]} 0%, ${pair[1]} 100%)`;
}

export function avatarInitial(name: string): string {
  // 取首个字母/汉字/符号,大写
  const trimmed = name.trim();
  if (!trimmed) return "?";
  const first = trimmed[0]!;
  return first.toUpperCase();
}
